<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";

/**
 * Invoice-detail component
 */
export default {
    components: {ErrorMessage, Layout, PageHeader },
    data() {
        return {
            errorMessage: "",
            title: "Invoice",
            items: [
                {
                    text: "Invoices",
                    href: "/"
                },
                {
                    text: "Invoice",
                    active: true
                }
            ],
            errors: null,
            bookingId:"",
            agent:"",
            passengers:[],
            tickets:[],
            booking:"",
            flight:"",
            visible:false,
            message:"",
        };
    },
    created() {
        this.bookingId = this.$route.params.id;
    },
    mounted() {
        this.getInvoiceDetail();
    },
    methods: {
        onClose(){
            this.visible=false;
        },
        sendMail(id) {

            try {
                axios
                    .post("/api/flight-booking-details-mail/" + id, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.$swal("Mail Sent Successfully");
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        async getInvoiceDetail() {
            try {
                axios
                    .post("/api/flight-booking/invoice/" + this.bookingId, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.booking=response.data.data;
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        errorCheck(obj) {
            if(obj.statusCode == 403){
                this.visible=true;
                this.message="Access Permission Denied";
                this.errors = obj.message;
            }else if (obj.error) {
                this.errors = obj.message;
            } else if (obj.message == "Token has expired") {
                this.$swal.fire({
                    title: 'LogOut!',
                    text: 'Token Has Expired',
                    icon: 'error',
                    toast:'true',
                    position: 'top-end',
                });
                this.$router.push({ name: "logout" });
            } else if (
                obj.message !== "Token has expired" &&
                obj.message !== "The given data was invalid."
            ) {
                this.errors = obj.message;
            } else if (obj.message == "The given data was invalid.") {
                this.errors = obj.errors;
            } else {
                this.flashMessage.show({
                    time: 5000,
                    status: "error",
                    title: "Error",
                    message: "Problem in data save",
                });
            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row" v-if="booking.account_type=='b2b'">
                            <div class="col-6">

                            </div>
                            <div class="col-6 text-right">
                                <address>
                                    <strong>Agent</strong>
                                    <br />{{booking.agent.first_name}} {{booking.agent.last_name}}
                                    <br/>{{booking.agent.email}}
                                    <br/>{{booking.agent.phone_code}}{{booking.agent.phone_number}}
                                    <br />{{booking.agent.address}}
                                    <br />{{booking.agent.city}} {{booking.agent.postal_code}}
                                    <br/>{{booking.agent.country}}

                                </address>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-6">

                            </div>
                            <div class="col-6 text-right">
                                <address>
                                    <strong>To</strong>
                                    <br/>info@tripegate.com
                                    <br/>+1 (862) 290 2908
                                    <br />2605, 2nd Street
                                    <br />FL: 3, Astoria,
                                    <br />NY 11102, USA
                                </address>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table  mb-0 table-striped">
                                <thead>
                                <tr>
                                    <th style="width: 70px;">No.</th>
                                    <th>Pax Name</th>
                                    <th>
                                        <div>
                                            Airline/
                                        </div>
                                        <div>
                                            Pnr
                                        </div>
                                    </th>
                                    <th>Booking Date</th>
                                    <th>Flying Date</th>
                                    <th>Ticket No.</th>
<!--                                    <th>Currency</th>-->
                                    <th>Base Fare</th>
                                    <th>Tax</th>
                                    <th>Gross Fare</th>
                                    <th>Ait</th>
                                    <th>Markup</th>
                                    <th>Commission</th>
                                    <th class="text-right">Invoice Fare</th>
                                </tr>
                                </thead>
                                <tbody v-for="(passenger,index) in booking.flight_passengers" v-bind:key="index">
                                <tr>
                                    <td>{{index+1}}</td>
                                    <td>
                                        <div class="row">
                                            {{passenger.prefix}} {{passenger.first_name}} {{passenger.last_name}}
                                        </div>
                                        <div class="row">
                                            {{passenger.passenger_type}}
                                        </div>
                                    </td>
<!--                                    <td></td>-->
                                    <td>
                                        <div>
                                            {{booking.airline}}
                                        </div>
                                        <div>
                                            {{booking.airline_pnr}}
                                        </div>
                                    </td>
<!--                                    <td></td>-->
                                    <td>{{booking.created_at |  moment("D MMM YYYY, H:mm")}}</td>
                                    <td>{{booking.flight_segments[0].destination_date |  moment("D MMM YYYY, H:mm")}}</td>
                                    <td>
                                        {{passenger.flight_ticket==null ? 'N/A' : passenger.flight_ticket.ticket_no}}
                                    </td>
<!--                                    <td>{{passenger.currency}}</td>-->
                                    <td>{{passenger.base_fare}}</td>
                                    <td>{{passenger.total_tax}}</td>
                                    <td>{{passenger.gross_fare}}</td>
                                    <td>{{passenger.ait}}</td>
                                    <td>{{passenger.markup}}</td>
                                    <td>{{passenger.commission}}</td>
<!--                                    <td>{{ (passenger.invoice_fare-passenger.gross_fare).toFixed(2) }}</td>-->
                                    <td class="text-right">{{passenger.invoice_fare}}</td>
                                </tr>
                                </tbody>
                                <tr>

                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
<!--                                    <td></td>-->
<!--                                    <td></td>-->
<!--                                    <td></td>-->
                                    <td colspan="2" class="text-right">Sub Total</td>
<!--                                    <td class="text-right">{{booking.currency}}</td>-->
                                    <td class="text-right"> {{booking.gross_fare}}</td>
                                </tr>
                                <tr>

                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>

<!--                                    <td></td>-->
<!--                                    <td></td>-->
                                    <td colspan="2" class="border-0 text-right">
                                        <strong>(-)Discount</strong>
                                    </td>
<!--                                    <td class="border-0 text-right"></td>-->
                                    <td class="border-0 text-right">{{booking.commission}}</td>
                                </tr>
                                <tr>

                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
<!--                                    <td></td>-->
<!--                                    <td></td>-->
<!--                                    <td></td>-->
<!--                                    <td></td>-->
                                    <td colspan="2" class="border-0 text-right">
                                        <strong>Total</strong>
                                    </td>
                                    <td class="border-0 text-right">
                                        <h4 class="m-0">{{booking.currency}}</h4>
                                    </td>
                                    <td class="border-0 text-right">
                                        <h4 class="m-0">{{booking.invoice_fare}}</h4>
                                    </td>
                                </tr>
<!--                                </tbody>-->
                            </table>
                        </div>
                        <div class="d-print-none">
                            <div class="float-right">
                                <a href="javascript:window.print()" class="btn btn-success">
                                    <i class="fa fa-print"></i>
                                </a>
<!--                                <button @click.prevent="sendMail(booking.id)" class="btn btn-primary w-md ml-1">Send Email</button>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>
<!--<style >-->
<!--table.fixed { table-layout:fixed; }-->
<!--</style>-->
